export default "__VITE_ASSET__CebEjszC__"